// Coffescript compilation

var base, base1;

window.debug = function () {
  var ref;
  if (
    ((ref = window.console) != null ? ref.log : void 0) != null &&
    window.Settings.debug
  ) {
    return window.console.log.apply(console, arguments);
  }
};

window.console || (window.console = {});

(base = window.console).time || (base.time = $.noop);

(base1 = window.console).timeEnd || (base1.timeEnd = $.noop);

export default window.debug;
